import { render } from "./RelojDigital.vue?vue&type=template&id=742f9b72"
import script from "./RelojDigital.vue?vue&type=script&lang=js"
export * from "./RelojDigital.vue?vue&type=script&lang=js"

import "./RelojDigital.vue?vue&type=style&index=0&id=742f9b72&lang=css"

import exportComponent from "C:\\Users\\COSMI\\Desktop\\appwebantiguo\\vue-op-vanguardia\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__